import styled from "styled-components";
import { theme } from "../../../config";

export const Container = styled.div`
  height: 100%;
  width: 100%;
  background: ${theme.colors.white};
  box-shadow: 0px 0px 4px rgba(176, 139, 0, 0.1);
  border-radius: 8px;
`;

export const ContentPadding = styled.div`
  padding: 25px;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const Title = styled.div`
  font-family: "Orkney Bold";
  text-align: center;
  font-size: 16px;
  line-height: 18px;
  padding-top: 0.5em;
  color: #273049;
`;

export const LegendContainer = styled.div`
  flex-direction: row;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 17px;
`;

export const Legend = styled.div`
  background-color: ${(props: { passed: boolean }) =>
    props.passed ? "#30B6B3" : "#00918E"};
  width: 12px;
  height: 12px;
  border-radius: 2px;
`;

export const LegendTitle = styled.div`
  font-size: 12px;
  line-height: 16px;
  margin-left: 6px;
`;

export const LegendGroup = styled.div`
  display: flex;
  flex: 1;
  padding: 0 5px;

  &:nth-child(1) {
    justify-content: flex-end;
  }

  &:nth-child(2) {
    justify-content: flex-start;
  }
`;

export const FunnelGraphContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  ${(props: { isLoading?: boolean }) =>
    props.isLoading && `justify-content: center;height: 100%;`};
`;

export const FunnelGraph = styled.div`
  width: ${(props: { width: number | string; passed: boolean }) => props.width};
  background-color: ${(props: { width: number | string; passed: boolean }) =>
    props.passed ? "#30B6B3" : "#00918E"};

  padding: 6px;
  color: ${theme.colors.white};
`;

export const FunnelGraphDigit = styled.div`
  font-size: 16px;
  line-height: 21px;
  text-align: center;
`;

export const FunnelGraphTitle = styled.div<{
  inBetween?: boolean;
  margin?: string;
}>`
  font-size: 12px;
  line-height: 16px;
  text-align: center;
  white-space: nowrap;

  position: absolute;
  left: 0;
  right: 0;
  margin-top: 26px;
  margin-left: auto;
  margin-right: auto;
  width: 100px;
  color: ${theme.colors.white};
`;

export const FunnelGraphSplitContainer = styled.div`
  display: flex;
  height: 50px;
  margin-top: 16px;
  width: 100%;
  flex-direction: column;
`;

export const DropdownWrapper = styled.div`
  display: flex;
  justify-content: flex-end;

  anticon {
    line-height: 0px;
    height: 10px;
  }
`;

export const PassedDiv = styled.div`
  background-color: ${theme.colors.secondary1};
  flex: 1;
  text-align: center;
  padding-top: 4px;
  font-size: 16px;
  color: ${theme.colors.white};
`;

export const FailedDiv = styled.div`
  background-color: ${theme.colors.secondary};
  flex: 1;
  text-align: center;
  padding-top: 4px;
  font-size: 16px;
  color: ${theme.colors.white};
`;

export const SplitGraphWrapper = styled.div`
  display: flex;
  height: 100%;
  margin: 0 ${(props: { marginLR?: string }) => props?.marginLR || 0};
`;

export const GraphTitle = styled.span`
  font-size: 12px;
  line-height: 16px;
  text-align: center;
  white-space: nowrap;
  margin-top: -22px;
  background-color: transparent;
  color: ${theme.colors.white};
`;
